import React from 'react';
import { Box, Typography } from '@material-ui/core';

const boxProps = {
  bgcolor: 'background.paper',
  m: 1,
  borderColor: 'text.primary',
};

export default function ExitTacticSummaryBox({
  lossLimit,
  preserveProfit,
  underlyingPriceTrail,
  positionPriceTrail,
  candleTrail,
  grabCents,
  greenToRedCandles,
  greenToRedPositions,
  breakPrice,
  candleMagnitude,
  ratchetBracket,
}) {
  let lossLimitText = '';
  let preserveProfitText = '';
  let underlyingPriceTrailText = '';
  let positionPriceTrailText = '';
  let candleTrailText = '';
  let greenToRedCandlesText = '';
  let greenToRedPositionsText = '';
  let grabCentsText = '';
  let breakPriceText = '';
  let candleMagnitudeText = '';
  let ratchetBracketText = '';

  if (lossLimit !== undefined) {
    lossLimitText = (
      <>
        <b>Loss limit</b>: amount: {lossLimit.amount}
        <b>Loss limit</b>: percent: {lossLimit.percent}
        <br />
      </>
    );
  }
  if (preserveProfit !== undefined) {
    preserveProfitText = (
      <>
        <b>Preserve profit</b>: amount: {preserveProfit.amount}{' '}
        activationProfitAmount: {preserveProfit.activationProfitAmount}
        <br />
      </>
    );
  }
  if (underlyingPriceTrail !== undefined) {
    underlyingPriceTrailText = (
      <>
        <b>Underlying price trail</b>: amount: {underlyingPriceTrail.amount}
        <br />
      </>
    );
  }

  if (positionPriceTrail !== undefined) {
    positionPriceTrailText = (
      <>
        <b>Position price trail</b>: amount: {positionPriceTrail.amount}
        <br />
      </>
    );
  }

  if (candleTrail !== undefined) {
    candleTrailText = (
      <>
        <b>Candle trail</b>: candleDuration: {candleTrail.candleDuration},
        Pre/Post market: {JSON.stringify(candleTrail.usePrePostMarketData)}
        <br />
      </>
    );
  }
  if (grabCents !== undefined) {
    let qtyBasisPerLevel =
      grabCents.percentagePerLevel !== undefined
        ? 'pctPerLevel: ' + JSON.stringify(grabCents.percentagePerLevel)
        : 'qtyPerLevel: ' + JSON.stringify(grabCents.quantityPerLevel);

    let trailQtyBasis =
      grabCents.trailPercent !== undefined
        ? 'trailPct: ' + grabCents.trailPercent
        : 'trailQty: ' + grabCents.trailQuantity;
    grabCentsText = (
      <>
        <b>Grab cents</b>: centsPerLevel:{' '}
        {JSON.stringify(grabCents.centsPerLevel)}, {qtyBasisPerLevel},{' '}
        {trailQtyBasis}, trail: {grabCents.trailAmount}
        <br />
      </>
    );
  }
  if (greenToRedCandles !== undefined) {
    greenToRedCandlesText = (
      <>
        <b>Green to Red Candles</b>: rightDirection:{' '}
        {greenToRedCandles.inRightDirectionPct}, retrace:{' '}
        {greenToRedCandles.retracePct}, candleDuration:{' '}
        {greenToRedCandles.candleDuration}, minCandleHeight:
        {greenToRedCandles.minCandleHeight}
        <br />
      </>
    );
  }
  if (greenToRedPositions !== undefined) {
    greenToRedPositionsText = (
      <>
        <b>Green to Red Positions</b>: rightDirection:{' '}
        {greenToRedPositions.inRightDirectionPct}, retrace:{' '}
        {greenToRedPositions.retracePct}, pnlTrackingType:{' '}
        {greenToRedPositions.pnlTracking}
        <br />
      </>
    );
  }

  if (breakPrice !== undefined) {
    breakPriceText = (
      <>
        <b>Break Price</b>: prices: {JSON.stringify(breakPrice.prices)}
        <br />
      </>
    );
  }
  if (ratchetBracket !== undefined) {
    if (ratchetBracket.mode === 'EQUAL_INTERVAL') {
      ratchetBracketText = (
        <>
          <b>Ratchet Bracket</b> : mode: {ratchetBracket.mode}. target:{' '}
          {ratchetBracket.targetPerBracket}. stop:{' '}
          {ratchetBracket.stopPerBracket}. qtyBasis: {ratchetBracket.qtyBasis}.
          qtyBasisValue: {ratchetBracket.qtyBasisValuePerBracket}.
          trailQtyBasisValue: {ratchetBracket.trailQtyBasisValue}.
          <br />
        </>
      );
    }
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      border={1}
      {...boxProps}
    >
      <Typography style={{ fontSize: 10 }}>
        {lossLimitText}
        {preserveProfitText}
        {underlyingPriceTrailText}
        {positionPriceTrailText}
        {candleTrailText}
        {grabCentsText}
        {greenToRedCandlesText}
        {greenToRedPositionsText}
        {breakPriceText}
        {ratchetBracketText}
      </Typography>
    </Box>
  );
}
